import { ArrowRight, Check, Lock } from "lucide-react";

import { track } from "@/lib/analytics";
import { demoResultsUrl } from "@/lib/apex25AppUrl";

import type { DemoRole } from "./demo-api";
import { setLastDemoAuth } from "./last-demo";

type Props = { role: DemoRole; sessionId: string };

// The end of the public half of the demo. tryapex25.com has no sign-in (Clerk only runs on
// recruit.theresume.io), so both buttons are plain links to the results page there, which sends a
// signed-out visitor to the Apex 25-branded sign-up or sign-in screen and back again. They must
// stay <a> elements: the handoff decorator adds first-touch attribution to app links on click.
export const SignInToSeeResults = ({ role, sessionId }: Props) => {
  const onClick = (auth: "signup" | "signin") => () => {
    setLastDemoAuth(auth);
    track("apex25_demo_results_auth", { role: role.id, auth });
  };

  return (
    <div className="a25-panel a25-gate">
      <Lock size={20} aria-hidden="true" className="a25-lock" />
      <h3 tabIndex={-1}>Sign up to see your results</h3>
      <p className="a25-gate-body">
        Your interview for {role.title} at {role.company} is saved.
      </p>
      <ul className="a25-list">
        <li>
          <Check size={14} aria-hidden="true" />
          Review your interview transcript, answer by answer
        </li>
        <li>
          <Check size={14} aria-hidden="true" />
          Ask the AI how you compare with the shortlisted candidates, with cited evidence
        </li>
      </ul>
      <div className="a25-actions a25-gate-actions">
        <a
          className="btn a25-nudge"
          data-next-step="See your results"
          href={demoResultsUrl(sessionId, "signup")}
          onClick={onClick("signup")}
        >
          Create a free account to get started <ArrowRight size={16} aria-hidden="true" />
        </a>
        <p className="a25-gate-signin">
          Already have an account?{" "}
          <a href={demoResultsUrl(sessionId, "signin")} onClick={onClick("signin")}>
            Sign in
          </a>
        </p>
      </div>
      <p className="a25-note">Your results are kept for 2 hours, then deleted.</p>
    </div>
  );
};
